export default __webpack_public_path__ + "static/img_mv_stroke-c5a38ca510e64125f366e278966648c2.png";